import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
import {
  CategoriesNav,
  NavItem,
  NavHeader,
  HorizontalRule,
} from './styles';

const CategoryList = ({ navItems, onSelectCategory, selectedCategory }) => (
  <CategoriesNav>
    <NavHeader>
      <FormattedMessage {...messages.categories} />
    </NavHeader>
    {navItems.map(({ key, text, hr, type }, index) =>
      hr
        ? <HorizontalRule key={key || `pluginSelection-navItem-${index}`} />
        : <NavItem
          key={key || `pluginSelection-navItem-${index}`}
          active={key === selectedCategory}
          onClick={hr ? null : onSelectCategory(key, type)}
        >
          {text}
        </NavItem>
    )}
  </CategoriesNav>
);

CategoryList.propTypes = {
  selectedCategory: PropTypes.string,
  onSelectCategory: PropTypes.func,
  navItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    key: PropTypes.string,
  })),
};

export default CategoryList;
